module.exports = __webpack_public_path__ + "img/900.59571aef.png";